import {
  bodyTextPreset,
  headingTextPreset,
  spacingVars,
} from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

const CLOSE_ICON_FONT_SIZE = '24px';

export const slideoverHeaderClass = style({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: spacingVars.lg,
  padding: `0 0 ${spacingVars['3xl']}`,
});

export const slideoverHeaderTextClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: spacingVars.sm,
  flex: '1 1 auto',
  minWidth: 0,
});

export const slideoverHeaderTitleClass = style({
  ...headingTextPreset,
  margin: 0,
});

export const slideoverHeaderBodyClass = style({
  ...bodyTextPreset,
  margin: 0,
});

export const closeSlideoverButtonClass = style({
  fontSize: CLOSE_ICON_FONT_SIZE,
  flex: '0 0 auto',
});
